import { useNavigate, useSearchParams } from 'react-router-dom'

import { SearchBusinesses } from '../components/business/SearchBusinesses'
import { CompanySearchResult } from '../lib/api'

import { SceneContainer } from '../components/scene/SceneContainer'

const SearchBusinessesScreen = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()

  const searchTerm = searchParams.get('search') || ''

  const handleSearchChange = (newSearch: string) => {
    if (newSearch) {
      setSearchParams({ search: newSearch })
    } else {
      setSearchParams({})
    }
  }

  const handleSelectBusiness = async (business: CompanySearchResult) => {
    navigate(`/new-business/${business.companyNumber}`)
  }

  return (
    <SceneContainer
      title="Find your business"
      description="Search for your business by name or company number"
    >
      <SearchBusinesses
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        onSelectBusiness={handleSelectBusiness}
      />
    </SceneContainer>
  )
}

export default SearchBusinessesScreen
